@if (!includeButton) {
  <div class="d-flex flex-lg-column" [ngClass]="{'no-text' : !showText, 'show-text': showText}">
    @for (btn of shareBtns; track btn) {
      <div [ngClass]="btn + '-share-btn'" class="share-btn d-inline-block">
        <share-button
          [button]="btn"
          [ngClass]="'btn'"
          [showText]="showText"
          [text]="'Share by ' + btn | translate"
          [showIcon]="false"
          [url]="url"
          class="d-block">
        </share-button>
      </div>
    }
  </div>
} @else {
  <div class="share-wrapper d-inline-block position-relative">
    <button  [matMenuTriggerFor]="menu" aria-haspopup="menu" (menuOpened)="addOverlayClass()" (menuClosed)="removeOverlayClass()" attr.aria-expanded="{{shareBtn.menuOpen}}" class="btn btn-flat mx-4 btn-action app-btn-" title="{{'Share'|translate}}"  #shareBtn="matMenuTrigger">
      <img src="/assets/images/share.svg" alt="{{'Share'|translate}}">   <span>{{'sharing' |translate}}</span>
    </button>
    <mat-menu #menu="matMenu"  class="social-wrapper">
      <ul class="d-flex flex-lg-column flex-column p-0 m-0" [ngClass]="{'no-text' : !showText, 'show-text': showText}">
        @for (btn of shareBtns; track btn) {
          <li mat-menu-item [ngClass]="btn + '-share-btn'" class="share-btn d-inline-block p-0">
            @if (btn !== 'email') {
              <share-button
                [button]="btn"
                [ngClass]="'btn'"
                [showText]="showText"
                [text]="'Share by ' + btn | translate"
                [showIcon]="false"
                [url]="url"
                class="d-block">
              </share-button>
            }
            @if (btn === 'email') {
              <share-button
                [button]="btn"
                [ngClass]="'btn'"
                [showText]="showText"
                [text]="'Share by ' + btn | translate"
                [showIcon]="false"
                [url]="url"
                [title]="titleEmail"
                [description]="bodyEmail"
                class="d-block">
              </share-button>
            }
          </li>
        }
      </ul>
    </mat-menu>
  </div>
}
